<template>
  <div :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"></div>
</template>

<script>
import meishanshi from "@/assets/json/meishanshi.json";
export default {
  props: {
    id: {
      type: String | Number,
      default: "1",
    },
  },
  data() {
    return {
      pointData: [],
    };
  },
  methods: {
    async drawLine() {
      let _this = this;
      // let geoCoordMap = [
      //   {
      //     name: "洪雅县人民医院",
      //     value: [103.38683, 29.90678],
      //   },
      // ];
      // console.log(this.chartsData);
      if (document.getElementById(this.id) == null) {
        return;
      }
      let myChart = this.$echarts.getInstanceByDom(
        document.getElementById(this.id)
      );
      if (!myChart) {
        myChart = this.$echarts.init(document.getElementById(this.id));
      }
      myChart.setOption({}, true);
      let option = {
        backgroundColor: "transparent",
        // 地图配置
        geo: [
          {
            map: "眉山",
            aspectScale: 1,
            zoom: 0.65,
            layoutCenter: ["50%", "45%"],
            layoutSize: "150%",
            show: true,
            roam: false,
            emphasis: {
              label: {
                show: false,
              },
            },
            itemStyle: {
              borderColor: "#c0f3fb",
              borderWidth: 1,
              shadowColor: "#8cd3ef",
              shadowOffsetY: 10,
              shadowBlur: 120,
              areaColor: "transparent",
            },
          },
          // 重影
          {
            type: "map",
            map: "眉山",
            zlevel: -1,
            aspectScale: 1,
            zoom: 0.65,
            layoutCenter: ["50%", "46%"],
            layoutSize: "150%",
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              // borderColor:"rgba(17, 149, 216,0.6)",
              borderColor: "rgba(58,149,253,0.8)",
              shadowColor: "rgba(172, 122, 255,0.5)",
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: "rgba(5,21,35,0.1)",
            },
          },
          {
            type: "map",
            map: "眉山",
            zlevel: -2,
            aspectScale: 1,
            zoom: 0.65,
            layoutCenter: ["50%", "47%"],
            layoutSize: "150%",
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              // borderColor: "rgba(57, 132, 188,0.4)",
              borderColor: "rgba(58,149,253,0.6)",
              shadowColor: "rgba(65, 214, 255,1)",
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: "transpercent",
            },
          },
          {
            type: "map",
            map: "眉山",
            zlevel: -3,
            aspectScale: 1,
            zoom: 0.65,
            layoutCenter: ["50%", "48%"],
            layoutSize: "150%",
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              // borderColor: "rgba(11, 43, 97,0.8)",
              borderColor: "rgba(58,149,253,0.4)",
              shadowColor: "rgba(58,149,253,1)",
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: "transpercent",
            },
          },
          {
            type: "map",
            map: "眉山",
            zlevel: -4,
            aspectScale: 1,
            zoom: 0.65,
            layoutCenter: ["50%", "49%"],
            layoutSize: "150%",
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 5,
              // borderColor: "rgba(11, 43, 97,0.8)",
              borderColor: "rgba(5,9,57,0.8)",
              shadowColor: "rgba(29, 111, 165,0.8)",
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: "rgba(5,21,35,0.1)",
            },
          },
        ],
        series: [
          {
            name: "眉山市数据",
            type: "map",
            map: "眉山", // 自定义扩展图表类型
            aspectScale: 1,
            zoom: 0.65, // 缩放
            showLegendSymbol: true,
            label: {
              show: true,
              color: "#fff",
              fontSize: "120%",
            },
            itemStyle: {
              areaColor: {
                type: "linear",
                x: 1200,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(3,27,78,0.75)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(58,149,253,0.75)", // 50% 处的颜色
                  },
                ],
                global: true, // 缺省为 false
              },
              borderColor: "#fff",
              borderWidth: 0.2,
              itemStyle: {
                show: false,
                color: "#fff",
                areaColor: "rgba(0,254,233,0.6)",
              },
            },
            layoutCenter: ["50%", "45%"],
            layoutSize: "150%",
            markPoint: {
              symbol: "none",
            },
          },
          {
            name: "point",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: this.pointData,
            symbolSize: 15,
            tooltip: {
              show: false,
            },
            encode: {
              value: 2,
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
              color: "#0efacc",
              period: 9,
              scale: 5,
            },
            emphasis: {
              scale: true,
            },
            label: {
              formatter: "{b}",
              position: "top",
              distance: 10,
              show: true,
              color: "#fff",
              padding: [7, 12],
              backgroundColor: {
                image: require("@/assets/images/msgt/txtBg.png"),
              },
            },
            itemStyle: {
              color: "#0efacc",
              shadowBlur: 2,
              shadowColor: "#333",
            },
            zlevel: 1,
          },
        ],
      };
      this.$echarts.registerMap("眉山", meishanshi);
      myChart.setOption(option, true);
      myChart.off("click");
      myChart.on("click", function (params) {
        _this.$bus.$emit("handleNumberChange", "change");
      });
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  created() {},
  mounted() {
    this.$bus.$on("getCommandMap", (data) => {
      this.pointData = data;
      this.drawLine();
    });
    this.drawLine();
  },
  beforeDestroy() {
    this.$bus.$off("getCommandMap");
  },
};
</script>

<style scoped lang="scss"></style>
